import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { AiFillFileAdd } from 'react-icons/ai';
import Drawer from '@mui/material/Drawer';
import { useMutation, useQueryClient } from 'react-query';
import useOnUpdate from '../../hooks/useOnUpdate';
import { editCarousel, deleteMessages } from '../../api/ticker';
import convertTinyInt from '../../utils';
import { useGlobalData } from '../../context/globalData';

import Preview from '../bottomMenu/Preview';
import MenuNewMessage from '../bottomMenu/MenuNewMessage';



import SwitchButton from '../../components/SwitchButton';
import SearchInput from '../../components/SearchInput';
import UrgentStatus from '../../components/UrgentStatus';

function MessageBox(props) {
  const queryClient = useQueryClient();
  const { globalData } = useGlobalData();
  const [searchValue, setSearchValue] = useState('');
  
  const {
    messages,
    title,
    columns,
    list,
    hideSearch,
    hideActiveButton,
    carousel,
    disableSort,
    hideOptionalButton,
    hideUrgentStatus,
    className,
    setNotifications,
    options,
    type,
    showOkPopup,
    languages,
  } = props;
  const Component = list;
  const [sideMenu, setSideMenu] = useState(false);
  const [messageData, setMessageData] = useState({});
  const [preview, setPreview] = useState(null);
  const [switchButtonChecked, setSwitchButtonChecked] = useState(carousel.isActive)
  const messagesMapping = () =>
    messages
      .map((msg) => {
        const template = globalData.templates.filter((item) => item.templateID === msg.templateID)[0];
        const msgContent = msg.messageData.sort((a, b) => a.field.localeCompare(b.field, 'en', { sensitivity: 'base' }))
          .filter((item) => item.value)
          .map((item) => item.value)
          .join(' | ');
        return { ...msg, templateLabel: template.label, content: msgContent };
      })
      .sort((a, b) => a.position - b.position);

  const [messageList, setMessageList] = useState(messagesMapping());

  const { mutate: removeAllMessages } = useMutation(() => deleteMessages(messages.map(m => m.messageID)), {
    onSuccess: () => {
      queryClient.invalidateQueries('tickerData');
      queryClient.invalidateQueries('synchroDB');
      queryClient.invalidateQueries('xmlData');
    },
  });

  const { mutate: updateCarousel } = useMutation((data) => {
    if (carousel.type === 1 || !messageList.length) {
      showOkPopup("Le carrousel urgent ne peut être activé si la liste antenne est vide")
      return;
    }
    editCarousel(data, data.carouselID)
  }, {
    onSuccess: (data) => {
      queryClient.invalidateQueries('tickerData');
      queryClient.invalidateQueries('synchroDB');
      queryClient.invalidateQueries('xmlData');
      setNotifications((prev) => [...prev, { message: data.message }]);
    },
  });

  const removeMessages = () => {
    removeAllMessages();
  }

  const offCarouselsExceptThis = () => {
    const carousels = globalData.carousels.map((c) => c);

    console.log(carousels);

    for(let i = 0; i< carousel.length; i++){
      if((carousel[i].type === 2 || carousel[i].type === 5 )
        && (carousel.type === 2 || carousel.type === 5)
        && carousel.isActive === 0
        && carousel[i].languageID === carousel.languageID 
        && carousel[i].carouselID !== carousel.carouselID
        ){
          carousel[i].isActive = 1;
        }
    }

    globalData.carousels = carousels;
  }

  useOnUpdate(() => {
    setMessageList(
      messagesMapping().filter((msg) => `${msg.templateLabel} ${msg.content}`.toLowerCase().includes(searchValue.toLowerCase())),
    );
  }, [messages]);


  useOnUpdate(() => {
    setPreview({ loading: false, file: '' });
  }, [sideMenu]);

  return (
    <div style={type !== 'antenne' ? { backgroundColor: "var(--dark-700)" } : {}} className={`${className} messageBox border-r border-zinc-900 border-t-0`}>
      <div className="messageBoxHeader">
          {!hideActiveButton && [2,5].includes(carousel.type) && (
          <div style={![2, 5].includes(carousel.type) && type === 'antenne' ? { display: "none" } : {}} className="grid grid-cols-2 w-full justify-between p-4 h-14">
            <div className="space-x-3 w-18 flex items-center">
              <span className="w-6 block">{switchButtonChecked ? 'ON' : 'OFF'}</span>
              <SwitchButton
                className="self-end"
                // disabled={carousel.type === 1 || !messageList.length}
                onClick={(e) => { 
                  if (carousel.type === 1 || !messageList.length) {
                    showOkPopup("Le carrousel urgent ne peut être activé si la liste antenne est vide")
                    return;
                  }
                  
                  console.log(globalData);
                  setSwitchButtonChecked(e.target.checked);
                  offCarouselsExceptThis();
                  updateCarousel({ ...carousel, isActive: e.target.checked }) 
                }}
                checked={convertTinyInt(switchButtonChecked)}
              />
            </div>
          </div>
          )}

        {(!hideUrgentStatus || (!hideSearch && type !== 'antenne')) && (
          <div style={{display:'flex', gap:`${5}px`, justifyContent: 'flex-end', alignItems: 'flex-end'}} className='p-4 h-14'>
            {!hideUrgentStatus && (
              <div>
                <UrgentStatus
                  carousel={carousel}
                />
              </div>
            )}
            {!hideSearch && type !== 'antenne' && (
              <div style={{ minWidth: '100px', maxWidth: '350px', width: '60%' }}>
                <SearchInput
                  setSearchValue={setSearchValue}
                  messages={messages}
                  messagesMapping={messagesMapping}
                  setMessageList={setMessageList}
                />
              </div>
            )}
          </div>
        )}

        <div style={type === 'antenne' ? { position: 'relative' } : {}}>
          <div style={type === 'antenne' ? { position: 'absolute', color: '#808080', top: "8px", right: "10px" } : {}}>
            {!hideSearch && type === 'antenne' && (
              <SearchInput
                classAttr="border-grey placeholder-grey"
                setSearchValue={setSearchValue}
                messages={messages}
                messagesMapping={messagesMapping}
                setMessageList={setMessageList}
              />
            )}
          </div>
          <div style={{ justifyContent: "space-between" }} className={type === 'antenne' ? "antenne-title flex items-center mb-2 text-black" : "flex items-center mb-2"}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h2 title={title} className="messageTitle  py-1 px-2 whitespace-nowrap overflow-ellipsis overflow-hidden">
                {title} :
              </h2>
              <span className={type === 'antenne' ? "antenne-qty text-black font-bold" : ""}>{messageList.length}</span>
            </div>
            {type !== 'antenne' && (
              <button type="button" onClick={() => {
                removeMessages()
              }} className="remove-messages-btn">Vider la liste</button>
            )}
          </div>
          <div className="listHeaderGrid grid grid-cols-1 gap-2 items-center pb-2 p-2">
            {/* titres colonnes Type et Contenu  */}
            {columns.headers.map((col) => (
              <div title={col.content} key={`header_${col.id}`} className={type === 'antenne' ? "text-zinc-400 overflow-ellipsis overflow-hidden text-black" : "text-zinc-400 overflow-ellipsis overflow-hidden"}>
                {col.content}
              </div>
            ))}

            {!hideOptionalButton && (
              <div className="w-fit  col-start-3 justify-self-end">

                {/* bouton tri messages */}
                {/* <button
                  type="button"
                  onClick={() => {
                    messagesAlphabeticalSort({});
                  }}
                  id="alphabeticalSortButton"
                >
                  <AiOutlineSortAscending size={22} />
                </button> */}

                {/* bouton creation message */}
                <button
                  type="button"
                  onClick={() => {
                    setMessageData({});
                    setSideMenu(true);
                  }}
                  id="newMsgButton"
                >
                  <span>Nouveau</span>

                  {/* <AiFillFileAdd size={22} /> */}
                </button>
              </div>
            )}

            {/* menu crea msg et preview */}
            <Drawer
              className="drawer"
              anchor="bottom"
              ModalProps={{ onClose: null }}
              open={sideMenu}
              onClose={() => {
                setSideMenu(false);
              }}
            >
              <div className="grid grid-cols-2">
                <MenuNewMessage
                  setNotifications={setNotifications}
                  setSideMenu={setSideMenu}
                  carousel={carousel}
                  messageData={messageData}
                  setPreview={setPreview}
                  setMessageData={setMessageData}
                  languages={languages}
                />
                <Preview preview={preview} />
              </div>
            </Drawer>
          </div>
        </div>
      </div>
      <Component
        disableSort={disableSort}
        options={options}
        messages={messageList}
        type={type}
        columns={columns}
        setNotifications={setNotifications}
        setSideMenu={setSideMenu}
        setMessageData={setMessageData}
        carousel={carousel}
        showOkPopup={showOkPopup}
      />
    </div>
  );
}

MessageBox.propTypes = {
  messages: PropTypes.array,
  type: PropTypes.string,
  carousel: PropTypes.object,
  title: PropTypes.string,
  columns: PropTypes.object,
  list: PropTypes.func,
  hideSearch: PropTypes.bool,
  hideActiveButton: PropTypes.bool,
  hideOptionalButton: PropTypes.bool,
  hideUrgentStatus:PropTypes.bool,
  disableSort: PropTypes.bool,
  className: PropTypes.string,
  setNotifications: PropTypes.func,
  options: PropTypes.object,
  showOkPopup: PropTypes.func,
  languages: PropTypes.array
};

MessageBox.defaultProps = {
  messages: [],
  type: '',
  carousel: {},
  title: '',
  columns: {},
  list: <div />,
  hideSearch: false,
  hideActiveButton: false,
  hideOptionalButton: false,
  hideUrgentStatus: false,
  disableSort: false,
  options: {},
  className: '',
  languages: [],
  setNotifications: () => { },
  showOkPopup: () => { }
};

export default MessageBox;
